import React from 'react'
import { Link } from 'react-router-dom'
import './../styles/CardComponent.css'

const CardComponent = ({
  title,
  body,
  image,
  icon,
  to,
  featured = false,
  ctaLabel = 'Learn more',
}) => {
  const inner = (
    <>
      {image ? (
        <img src={image} alt={title} className="card-image" />
      ) : icon ? (
        <div className="card-icon-container">
          <div className={`card-icon ${icon}`}></div>
        </div>
      ) : null}
      <div className="card-content">
        <h2 className="card-title">{title}</h2>
        <p className="card-body">{body}</p>
        {to && (
          <span className="card-link">
            {ctaLabel} <span aria-hidden="true">&rarr;</span>
          </span>
        )}
      </div>
    </>
  )

  const className = [
    'card',
    to ? 'card--link' : '',
    featured ? 'card--featured' : '',
  ]
    .filter(Boolean)
    .join(' ')

  if (to) {
    return (
      <Link to={to} className={className}>
        {inner}
      </Link>
    )
  }

  return <div className={className}>{inner}</div>
}

export default CardComponent
